export const getTotalPrice = item => {
    if (item && item.rate && item.rate.amount != null) {
        const promoCodeDiscount = item.promoCode ? item.promoCode.promoDiscount : 0
        const price = item.rate.amount - promoCodeDiscount

        return price >= 0 ? price : 0
    }
    return null
}

export const sumCalculator = (items, prop) => items.reduce((a, b) => a + (b[prop] || 0), 0)
